import type { GetTeamsArgs } from './teamQuery';

export const codingKeys = {
	getCodingLists: 'getCodingLists',
	getProviderMapping: 'getProviderMapping',
	getProviderFields: 'getProviderFields',
	getCodingListsEntries: 'getCodingListsEntries',
	setCodingListsEntries: 'setCodingListsEntries',
	getCodingListEntries: 'getCodingListEntries',
	getTeamCodingListEntries: 'getTeamCodingListEntries',
	getInactiveCodingListEntries: 'getInactiveCodingListEntries',
};

export const teamKeys = {
	getTeams: ({ state, limit, offset }: GetTeamsArgs) => ['teams', state, limit, offset] as const,
	getAllTeams: () => ['all teams'] as const,
	getTeamProperty: 'getTeamProperty',
	getReport: 'getReport',
	getUserSettings: 'getUserSettings',
	getTeam: 'getTeam',
	getDecoratedUser: 'getDecoratedUser',
	getTeamUsers: 'getTeamUsers',
	verifyTeamAccess: 'verifyTeamAccess',
	getSelectedTeamProperty: 'getSelectedTeamProperty',
	getOooSettings: (teamId: string, userId: string | undefined) => ['oooSettings', teamId, userId] as const,
};

export type VerifyUserAccessParams = {
	objectId: string;
	operationId: string;
	teamId: string | undefined;
	userId: string | undefined;
	groupId: string | undefined;
};

export const userKeys = {
	getUser: ['user'] as const,
	getUserSettings: 'getUserSettings',
	getUserByEmail: (email: string) => ['users', 'email', email] as const,
	getUsersByRoleId: (roleId: string) => ['users', 'roleId', roleId] as const,
	getUserById: (id: string) => ['user', 'id', id] as const,
	getVerifyUserAccess: (params: VerifyUserAccessParams) =>
		({
			...params,
		}) as const,
	verifyTeamAccess: 'verifyTeamAccess',
};

export const featureKeys = {
	getFeatureList: 'getFeatureList',
};

export const requestKeys = {
	getRequestId: ['request', 'id'] as const,
	getRequestList: () => ['request', 'list'] as const,
	getRequest: (requestId: string) => ['request', requestId] as const,
	getRequests: (archived?: boolean) => ['requests', archived] as const,
	addTag: (requestId: string, tag: string) => ['request', requestId, 'tag', tag, 'add'] as const,
	removeTag: (requestId: string, tag: string) => ['request', requestId, 'tag', tag, 'remove'] as const,
	approve: (requestId: string) => ['request', requestId, 'approve'] as const,
	reject: (requestId: string) => ['request', requestId, 'reject'] as const,
	cancelRequest: (requestId: string) => ['request', requestId, 'cancel'] as const,
	submitRequest: (requestId: string) => ['request', requestId, 'submit'] as const,
};

export const requestProfileKeys = {
	getRequestProfilesForCompany: 'getRequestProfilesForCompany',
	getProfiles: 'getProfiles',
};

export const rolesKeys = {
	setRoles: 'setRoles',
	setRole: 'setRole',
	removeRoleFromUser: 'removeRoleFromUser',
};

export const currenciesKeys = {
	getCurrencies: (teamId: string | undefined) => ['currency', 'teamId', teamId] as const,
};
